import React from 'react'
import Image from './image.jsx';
import BackgroundImage from './background-image.jsx';

class DynamicImage extends React.Component {
    render () {
        let ImageComponent = this.props.isBackground ? BackgroundImage : Image
        return (
            <ImageComponent {...this.props} className={this.props.className + ' component-dynamic-image'} />
        )
    }
}

export default DynamicImage;



// WEBPACK FOOTER //
// ./web-app/components/dynamic-image.jsx